export function setENV(data: any): IEnvironment {
  let env = data;
  if (env.data && env.status === 200) {
    env = env.data;
  }
  const isExternalPro = window?.location?.href.includes(
    'https://helio.axpoiberia.es'
  );
  return {
    NAME:
      env.NAME ||
      (isExternalPro
        ? process.env.REACT_APP_ENVIRONMENT
        : process.env.REACT_APP_ENVIRONMENT_PRE) ||
      '',
    API_URL:
      env.API_URL ||
      (isExternalPro
        ? process.env.REACT_APP_API
        : process.env.REACT_APP_API_PRE) ||
      '',
    API_URL_MIC:
      env.API_URL_MIC ||
      (isExternalPro
        ? process.env.REACT_APP_API_MIC
        : process.env.REACT_APP_API_MIC_PRE) ||
      '',
    API_URL_OFFER_MIC:
      env.API_URL_OFFER_MIC ||
      (isExternalPro
        ? process.env.REACT_APP_API_OFFER_MIC
        : process.env.REACT_APP_API_OFFER_MIC_PRE) ||
      '',
    API_URL_NO_REL:
      env.API_URL_NO_REL ||
      (isExternalPro
        ? process.env.REACT_APP_NO_REL_API
        : process.env.REACT_APP_NO_REL_API_PRE) ||
      '',
    APP_URL_FORESCASTS:
      env.APP_URL_FORESCASTS ||
      (isExternalPro
        ? process.env.REACT_APP_URL_FORESCASTS
        : process.env.REACT_APP_URL_FORESCASTS_PRE) ||
      '',
    APP_URL_AVAILABILITIES:
      env.APP_URL_AVAILABILITIES ||
      (isExternalPro
        ? process.env.REACT_APP_URL_AVAILABILITIES
        : process.env.REACT_APP_URL_AVAILABILITIES_PRE) ||
      '',
    APP_SETTELEMENT:
      env.APP_SETTELEMENT ||
      (isExternalPro
        ? process.env.REACT_APP_SETTELEMENT
        : process.env.REACT_APP_SETTELEMENT_PRE) ||
      '',
    APP_MEASURE:
      env.APP_MEASURE ||
      (isExternalPro
        ? process.env.REACT_APP_MEASURE
        : process.env.REACT_APP_MEASURE_PRE) ||
      '',
    APP_INVOICE:
      env.APP_URL_INVOICE ||
      (isExternalPro
        ? process.env.REACT_APP_INVOICE
        : process.env.REACT_APP_INVOICE_PRE) ||
      '',
    APP_UNAVAILABILITIES:
      env.APP_URL_UNAVAILABILITIES ||
      (isExternalPro
        ? process.env.REACT_APP_UNAVAILABILITIES
        : process.env.REACT_APP_UNAVAILABILITIES_PRE) ||
      '',
    APP_STRATEGIES:
      env.APP_STRATEGIES ||
      (isExternalPro
        ? process.env.REACT_APP_STRATEGIES
        : process.env.REACT_APP_STRATEGIES_PRE) ||
      '',
    APP_OFFERT:
      env.APP_OFFERT ||
      (isExternalPro
        ? process.env.REACT_APP_OFFERT
        : process.env.REACT_APP_OFFERT_PRE) ||
      '',
    APP_UTILS:
      env.APP_UTILS ||
      (isExternalPro
        ? process.env.REACT_APP_UTILS
        : process.env.REACT_APP_UTILS_PRE) ||
      '',
    APP_LOGIN:
      env.APP_LOGIN ||
      (isExternalPro
        ? process.env.REACT_APP_LOGIN
        : process.env.REACT_APP_LOGIN_PRE) ||
      '',
    APP_BREAKDOWN:
      env.APP_BREAKDOWN ||
      (isExternalPro
        ? process.env.REACT_APP_BREAKDOWN
        : process.env.REACT_APP_BREAKDOWN_PRE) ||
      '',
    APP_DASHBOARD:
      env.APP_DASHBOARD ||
      (isExternalPro
        ? process.env.REACT_APP_DASHBOARD
        : process.env.REACT_APP_DASHBOARD_PRE) ||
      '',
    API_URL_SOCKET:
      env.API_URL_SOCKET ||
      (isExternalPro
        ? process.env.REACT_APP_SOCKET
        : process.env.REACT_APP_SOCKET_PRE) ||
      '',
    API_URL_BASIC:
      env.APP_BASIC ||
      (isExternalPro
        ? process.env.REACT_APP_BASIC
        : process.env.REACT_APP_BASIC_PRE) ||
      '',
    APP_NOTIFICATION:
      env.APP_NOTIFICATION ||
      (isExternalPro
        ? process.env.REACT_APP_NOTIFICATION
        : process.env.REACT_APP_NOTIFICATION_PRE) ||
      '',
    APP_OFFER_MIC:
      env.APP_OFFER_MIC ||
      (isExternalPro
        ? process.env.REACT_APP_OFFER_MIC
        : process.env.REACT_APP_OFFER_MIC_PRE) ||
      '',
    APP_MIC_WEBSOCKET:
      env.APP_MIC_WEBSOCKET ||
      (isExternalPro
        ? process.env.REACT_APP_MIC_WEBSOCKET
        : process.env.REACT_APP_MIC_WEBSOCKET_PRE) ||
      '',
    APP_DAO_MASTER_MICRO:
      env.APP_DAO_MASTER_MICRO ||
      (isExternalPro
        ? process.env.REACT_APP_DAO_MASTER_MICRO
        : process.env.REACT_APP_DAO_MASTER_MICRO_PRE) ||
      '',
    TABLE_COLUMNS_SMALL:
      env.TABLE_COLUMNS_SMALL || process.env.REACT_APP_NUM_COLUMNS_SMALL || 5,
    TABLE_COLUMNS: env.TABLE_COLUMNS || process.env.REACT_APP_NUM_COLUMNS || 15,
    TABLE_COLUMNS_LARGE:
      env.TABLE_COLUMNS_LARGE || process.env.REACT_APP_NUM_COLUMNS_LARGE || 25,
    TABLE_ROW: env.TABLE_ROW || process.env.REACT_APP_NUM_TABLE_ROW || 15,
  };
}
interface IEnvironment {
  NAME: string;
  API_URL: string;
  API_URL_MIC: string;
  API_URL_OFFER_MIC: string;
  API_URL_NO_REL: string;
  APP_URL_FORESCASTS: string;
  APP_URL_AVAILABILITIES: string;
  APP_STRATEGIES: string;
  APP_OFFERT: string;
  APP_UNAVAILABILITIES: string;
  APP_SETTELEMENT: string;
  APP_MEASURE: string;
  APP_INVOICE: string;
  APP_LOGIN: string;
  APP_UTILS: string;
  APP_BREAKDOWN: string;
  APP_DASHBOARD: string;
  API_URL_SOCKET: string;
  APP_NOTIFICATION: string;
  API_URL_BASIC: string;
  APP_OFFER_MIC: string;
  APP_MIC_WEBSOCKET: string;
  APP_DAO_MASTER_MICRO: string;
  TABLE_COLUMNS_SMALL: number;
  TABLE_COLUMNS: number;
  TABLE_COLUMNS_LARGE: number;
  TABLE_ROW: number;
}
